import { generateId } from '@freelancer/datastore/testing/helpers';
import type { JobClassifierCategory } from './job-classifier.backend-model';
import type { JobClassifier } from './job-classifier.model';

export function generateJobClassifierObject(
  skillIds: readonly number[],
  category: JobClassifierCategory,
): JobClassifier {
  return {
    id: generateId().toString(),
    skillIds,
    category,
  };
}
